import React from 'react'
import { Button } from '@nextui-org/react'
import { IconSparkles } from '@tabler/icons-react'

const SparkleButton = ({handleClick, isIconOnly, Icon, btnName }) => {
  return (
    <button
    isIconOnly={isIconOnly}
    onClick={handleClick}
    className="relative overflow-hidden group text-xs flex items-center gap-2.5 px-3 py-3 bg-primaryGradient rounded-2xl text-white font-semibold tracking-wide transition-all duration-300 hover:scale-105 hover:shadow-2xl shadow-lg"
    style={{
    boxShadow: '0 8px 32px rgba(102, 126, 234, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2)'
    }}
    >
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
        <div className="relative flex items-center gap-2.5">
            <div className="p-1 bg-white/20 rounded-lg backdrop-blur-sm">
                <Icon size="14" className="text-white" />
            </div>
            {
              !isIconOnly && <>
                  <span className="font-medium">{btnName}</span>
                  <IconSparkles size="14" className="text-white/80 animate-pulse" />
                </>
            }
        </div>
    </button>
  )
}

export default SparkleButton
